import Logo from "../../components/icons/Logo";
import Tap from "../../assets/img/Green-Touch-Icon.gif";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useData } from "../../context/DataProvider";
import { useCallback } from "react";
import { Header } from "../../components/Header";
import CasinoFloor from "../../components/icons/NavIcons/CasinoFloor";
import Sportsbook from "../../components/icons/NavIcons/Sportsbook";
import PokerRoom from "../../components/icons/NavIcons/PokerRoom";

const CasinoPage = () => {
    const navigate = useNavigate();
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    return(
        <div className="page splash2 casinoPage">
            <Header />
            <div className="page-header">Casino</div>
            <div className="text-blocks">
                <div className="std-text">
                    Tailor your patron engagement to every venue 
                    within your casino. Whether it's patron self-
                    service using their own devices, or roaming
                    servers equipped with all-in-one mobile order 
                    and payment devices. You can maximize 
                    gambling time with minimal interruptions.
                </div>
            </div>
            <div className="logo" onClick={()=>{
                _logEvent('click', "Casino", "Agilysys");
                addFlow("Agilysys");
                navigate("/aboutus/agilysys");
            }}>
                <Logo />
            </div>
            <div className="casino-map">
                <div className="casino-floor">
                    <CasinoFloor onClick={()=>{
                        _logEvent('click', "Casino", "Casino Floor");
                        addFlow("Casino Floor");
                        navigate("casino-floor", { relative: "path" })
                    }} />
                </div>
                <div className="sportsbook">
                    <Sportsbook onClick={()=>{
                        _logEvent('click', "Casino", "Sportsbook");
                        addFlow("Sportsbook");
                        navigate("sportsbook", { relative: "path" })
                    }} />
                </div>
                <div className="poker-room">
                    <PokerRoom onClick={()=>{
                        _logEvent('click', "Casino", "Poker Room");
                        addFlow("Poker Room");
                        navigate("poker-room", { relative: "path" })
                    }} />
                </div>
            </div>
            <div className="tap">
                <img src={Tap} alt="" />
                <div className="tap-prompt">
                    Tap on each section of the map{'\n'}
                    To drill into the details
                </div>
            </div>
        </div>
    )
}

export default CasinoPage;